import { defineNuxtRouteMiddleware } from 'nuxt/app'
import { sanitize } from '../utility/sanitize'

export default defineNuxtRouteMiddleware(() => {
  const nuxtApp = useNuxtApp()
  // Skip on client-side
  if (process.server && nuxtApp.ssrContext?.event) {
    const config = useRuntimeConfig()

    // Set version header
    nuxtApp.ssrContext.event.node.res.setHeader(
      'X-Alfred-Version',
      config.public.alfredVersion,
    )

    // Update xkey header
    const currentXkey = nuxtApp.ssrContext.event.node.res.getHeader('xkey')
    const newXkey = sanitize(`alfredVersion:${config.public.alfredVersion}`)

    if (!currentXkey) {
      nuxtApp.ssrContext.event.node.res.setHeader('xkey', newXkey)
    } else {
      nuxtApp.ssrContext.event.node.res.setHeader(
        'xkey',
        `${currentXkey} ${newXkey}`,
      )
    }
  }
})
